
<div class="container">
  <br />
  <h2><adp-label labelKey="POC_PageTitle" [context]="data" class="theme-test"></adp-label></h2>
  <form id="label-text" class="col-md-8 col-sm-8 pl-1 pt-4" [formGroup]="testForm">
    <div class="card-row fullWidth  mt-3">
      <adp-input [resourceData]="getResource('FirstName')" formControlName="FirstName" >
      </adp-input>
    </div>
    <div class="card-row fullWidth  mt-3">
      <adp-input [resourceData]="getResource('LastName')" formControlName="LastName" >
      </adp-input>
    </div>
    <div class="card-row fullWidth  mt-3">
      <adp-input [resourceData]="getResource('Phone')" formControlName="Phone" >
      </adp-input>
    </div>
    <div class="card-row fullWidth  mt-3">
      <adp-select [resourceData]="getResource('Select_Languages')" formControlName="Languages"  [listItems]="languages"></adp-select>
    </div>
  </form>
  <a routerLink="/test-page2" routerLinkActive="router-link-active" >
    <adp-label labelKey="POC_GotoPage2"></adp-label>

  </a>
</div>
